import React from "react";
import locale from "../../common/locale";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import { Link } from "react-router-dom";
// import { Icon } from 'react-fa'

const SignupLink = props => {
  const { loc, message } = props;

  return (
    <div>
      <MuiThemeProvider>
        <div className="sign-up-link">
          {message === "add"
            ? locale.needToSignupBeforeAdd(loc)
            : locale.needToSignupBeforeLike(loc)}
          <ul className='add-modal'>
            <li>
              <Link to="users/facebook">
                <i class="fab fa-facebook-square fa-3x"></i>
                &emsp;{locale.signup_with_facebook(loc)}
              </Link>
            </li>
            <li>
              <Link to="users/twitter">
                <i class="fab fa-twitter-square fa-3x" />
                &emsp;{locale.signup_with_twitter(loc)}
              </Link>
            </li>
            <li>
              <Link to="/signup">
                <i className="fas fa-envelope fa-3x" />
                &emsp;{locale.signup_with_email(loc)}
              </Link>
            </li>
          </ul>
        </div>
      </MuiThemeProvider>
    </div>
  );
};

export default SignupLink;



// WEBPACK FOOTER //
// ./src/components/SignupLogin/SignupLink.js